// extracted by mini-css-extract-plugin
export default {"carousel":"cE-z"};